const nl = {
  home: {
    biometric_label: "BIOMETRISCHE IDENTITEITSVERIFICATIE",
    title: "Omgekeerd gezichten zoeken eenvoudig gemaakt",
    description:
      "Upload een hoogresolutieportret om kruisverwijzingen te maken met wereldwijde digitale archieven met geavanceerde neurale matching.",
    drag_drop: "Sleep uw afbeelding hierheen",
    file_formats: "Ondersteunt RAW, JPEG of PNG (Max 15MB)",
    select_file: "BESTAND SELECTEREN VAN SYSTEEM",
    initiate_scan: "Forensische Scan Starten",
    upload_hint: "UPLOAD EEN AFBEELDING OM DOOR TE GAAN",
    uploading: "Uploaden",
    searching: "Scannen",
    result_title: "Resultaten",
    drop_here: "Zet de afbeelding hier neer...",
    billion_faces: "Vergelijk met meer dan 1 miljard gezichten op internet",
    login_to_search: "Inloggen om te zoeken",
    login_required: "Log in of maak een account aan om deze app te gebruiken",
    not_enough_tokens: "Niet genoeg tokens",
    please_wait: "Even geduld, een paar minuten",
    leave_confirmation:
      "Er is een proces bezig. Weet je zeker dat je wilt vertrekken?",
  },
  sources: {
    section_title: "Bronnen die We Doorzoeken",
    social_media: {
      name: "Sociale Media",
      description:
        "Kruisverwijzingen via grote sociale netwerken en openbare profielen.",
    },
    web: {
      name: "Web",
      description:
        "Scant het open web op openbaar beschikbare gezichtsgegevens.",
    },
    scammers: {
      name: "Oplichters",
      description:
        "Vergelijkt met bekende oplichter-identiteits- en fraudedatabases.",
    },
    sexual_offenders: {
      name: "Zedendelinquenten",
      description:
        "Kruisverwijzingen met openbare geregistreerde delinquentenregisters.",
    },
    videos: {
      name: "Video's",
      description:
        "Extraheert en vergelijkt gezichten van openbare videoplatforms.",
    },
    police_photos: {
      name: "Politiefoto's",
      description: "Vergelijkt met openbaar beschikbare politiedatabases.",
    },
    news_and_blogs: {
      name: "Nieuws & Blogs",
      description: "Zoekt in nieuwsarchieven, redactionele inhoud en blogs.",
    },
  },
  header: {
    scan: "SCAN",
    history: "GESCHIEDENIS",
    pricing: "PRIJZEN",
    account: "ACCOUNT",
    logout: "UITLOGGEN",
    app_name: "Digital Forensicist",
  },
  footer: {
    copyright:
      "© 2024 Digital Forensicist. Alle rechten voorbehouden. Precisie Identiteitsverificatie.",
    privacy: "Privacybeleid",
    terms: "Servicevoorwaarden",
    docs: "Documentatie",
    support: "Ondersteuning",
  },
  common: {
    loading: "Laden...",
    error: "Fout",
    cancel: "Annuleren",
    back: "Terug",
  },
  errors: {
    upload_failed: "Upload mislukt. Probeer het opnieuw.",
    not_enough_tokens:
      "U heeft niet genoeg tokens om deze zoekopdracht uit te voeren.",
  },
  login: {
    disclaimer:
      "Je hebt een account nodig om deze app te gebruiken. We sturen geen spam en delen je e-mail niet. We raden aan om in te loggen met Apple voor meer privacy.",
  },
  results: {
    input_source: "INVOERBRON",
    match_thumbnail: "Miniatuur van de overeenkomst",
    extraction_id: "EXTRACTIE-ID",
    scan_analysis: "Scananalyse",
    scan_description:
      "Biometrische omgekeerde zoekopdracht voltooid. %{count} potentiële overeenkomsten gevonden in openbare registers en sociale indices.",
    col_identity_map: "IDENTITEITSKAART",
    col_verification_path: "VERIFICATIEPAD",
    col_bio_match_score: "BIO-OVEREENKOMSTSCORE",
    col_action: "ACTIE",
    export_pdf: "PDF exporteren",
    exporting: "Genereren...",
    verified: "GEVERIFIEERD",
    details: "DETAILS",
    details_tooltip: "Nauwkeurige gezichtsvergelijking uitvoeren",
    details_loading: "Vergelijken...",
    copied: "Gekopieerd!",
    copy_url: "URL kopiëren",
    displaying: "Weergave van %{count} van %{total} detecties",
  },
};

export default nl;
